import { render, staticRenderFns } from "./AllProducts.vue?vue&type=template&id=65b74425&scoped=true"
import script from "./AllProducts.vue?vue&type=script&lang=js"
export * from "./AllProducts.vue?vue&type=script&lang=js"
import style0 from "./AllProducts.vue?vue&type=style&index=0&id=65b74425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b74425",
  null
  
)

export default component.exports